import React from "react";

const StatusBorder = ({ children, number, grayborderColor = false }) => {
  const getBorderColor = () => {
    if (number > 80) {
      return "border-success-500";
    } else if (number > 40 && number < 70) {
      return "border-warning-500";
    } else {
      return "border-error-500";
    }
  };

  return (
    <div
      className={`p-0.5 rounded-full border-2 ${grayborderColor ? "border-gray-200" : getBorderColor()}`}
    >
      {children}
    </div>
  );
};

export default StatusBorder;
